import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { PaymentService } from '../../service/payment.service';
import { SharedService } from '@shared/services/shared.service';
import { InHomeCareLicenseService } from 'app/services/license/in-home-care/in-home-care-license.service';
import { IInHomeCareLicense } from 'app/models/licenses/in-home-care/in-home-care-license';
import { IHospitalLicense } from 'app/models/licenses/hospital/hospital-license';
import { HospitalLicenseService } from 'app/services/license/hospital/hospital-license.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'app-payment-slip',
  templateUrl: './payment-slip.component.html'
})

export class PaymentSlipDialog implements OnInit {
  public generating: boolean = false;
  public staffInbox: string = environment.staffInbox;
  public applicationSlipReference: string = 'AOBJ 1111';
  public annualSlipReference: string = 'AOBJ 2222';
  public entityType: string = '';
  public individualType: string = '';
  public showIndiviudalLicense: boolean = false;
  public isEntityLicense: boolean = false;
  public feeType: string = '';
  public application: boolean = false;
  public renewal: boolean = false;
  public change: boolean = false;
  public applicationFee: string = '$500';
  public renewalFee: string = '$10,000';
  public changeFee: string = '$5,000';
  public fee: string = '';
  public responsiblePartyName: string = ''
  public responsiblePartyPhone: string = ''
  public responsiblePartyEmail: string = ''
  public pageTitle:string = "";
  public licenseName:string = "";
  public licenseId: string = "";
  public applicationDate: string = "";

  constructor(public dialogRef: MatDialogRef<PaymentSlipDialog>,
              public paymentService: PaymentService,
              public ihcLicenseService: InHomeCareLicenseService,
              public hospitalLicenseService: HospitalLicenseService,
              public userService: UserService,
              public sharedService: SharedService,
              @Inject(MAT_DIALOG_DATA) public data: any){}

  ngOnInit(): void {
    this.determineFeeType();
    this.determineEntityType();
  }

  determineFeeType(): void{
    switch(this.data.feeType){
      case this.paymentService.applicationFeeType:
        this.feeType = 'Application Fee';
        this.application = true;
        break;
      case this.paymentService.renewalFeeType:
        this.feeType = 'Renewal Fee';
        this.renewal = true;
        break;
      case this.paymentService.changeFeeType:
        this.feeType = 'Change Fee';
        this.change = true;
        break;
    }
  }

  determineEntityType(): void{
    switch (this.data.entityType) {
      //In Home Care License
      case this.sharedService.inHomeCareLicense:
        this.generating = true;
        this.getIHCPaymentInfo();
          break;
      case this.sharedService.hospitalLicense:
        this.generating = true;
        this.getHospitalPaymentInfo();
          break;
    }
  }

  getIHCPaymentInfo(): void {
    let license: IInHomeCareLicense;
    this.ihcLicenseService.getLicenses().subscribe({
      next: response => {
        var checkLicense = response.find(l => l.id === this.data.id);
        if(checkLicense !== undefined){
          license = checkLicense;
        }
        //license = response.find(l => l.id === this.data.id);
        if(license != null){
          this.licenseName = license.entityName ?? '';
          this.responsiblePartyName = license.adminDesigneeName ?? '';
          this.responsiblePartyPhone = license.agencyPhone ?? '';
          this.responsiblePartyEmail = license.agencyEmail ?? '';
          this.licenseId = license.licenseId ?? '';
        }
      },
      error: e => {
        this.sharedService.toastr.error("Could not retrieve license information");
        console.log('error getting in home care license', e);
      },
      complete: () => {
        this.pageTitle = "In Home Care License " + license.classificationLevel + ' ' + this.feeType + " Payment Remittance Form";
        this.showIndiviudalLicense = false;
        this.isEntityLicense = true;
        this.generating = false;
        if(!license.isSubunit){
          this.entityType = this.paymentService.ihcSubunitPaymentOption;
        }
        else{
          switch(license.classificationLevel){
            case this.ihcLicenseService.limited:
              this.entityType = this.paymentService.ihcLimitedPaymentOption;
              break;
            case this.ihcLicenseService.basic:
              this.entityType = this.paymentService.ihcBasicPaymentOption;
              break;
            case this.ihcLicenseService.intermediate:
              this.entityType = this.paymentService.ihcIntermediatePayemntOption;
              break;
            case this.ihcLicenseService.comprehensive:
              this.entityType = this.paymentService.ihcComprehensivePaymentOption;
          }
        }
        this.fee = this.paymentService.getPaymentTypeAmount(this.data.sku);
      }
    });
  }

  getHospitalPaymentInfo(): void {
    let license: IHospitalLicense;
    this.hospitalLicenseService.getLicenses().subscribe({
      next: response => {
        var checkLicense = response.find(l => l.id === this.data.id);
        if(checkLicense !== undefined){
          license = checkLicense;
        }
        if(license != null){
          this.licenseName = license.entityName ?? '';
          this.responsiblePartyName = license.hospitalAdminName ?? '';
          this.responsiblePartyPhone = license.hospitalAdminPhone ?? '';
          this.responsiblePartyEmail = license.hospitalAdminEmail ?? '';
          this.licenseId = license.licenseId ?? '';
        }
      },
      error: e => {
        this.sharedService.toastr.error("Could not retrieve license information");
        console.log('error getting hospital license', e);
      },
      complete: () => {
         this.pageTitle = "Hospital License " + this.feeType + " Payment Remittance Form";
         this.showIndiviudalLicense = false;
         this.isEntityLicense = true;
         this.userService.getUserLicenses().subscribe({
           next: response => {
            let payments = response.find(l => l.id === license.id && l.type === this.data.entityType)?.payments.filter(p => !p.paid && p.type == this.data.feeType);
            this.fee = payments != undefined && payments != null && payments.length > 0 ? payments[0].amount : this.paymentService.getPaymentTypeAmount(this.data.sku);
             },
           error: e => {
             this.sharedService.toastr.error('Unable get user payment info.');
           }
         });
         this.generating = false;
      }
    });
  }

  getEmail(): string {
    if(this.data.entityType === this.sharedService.inHomeCareLicense){
      return 'mailbox.inhomecare@odhsoha.oregon.gov'
    }
    if(this.data.entityType === this.sharedService.hospitalLicense){
      return 'mailbox.hclc@ohdsoha.oregon.gov';
    }
    return '';
  }

  getPhone(): string {
    if(this.data.entityType === this.sharedService.inHomeCareLicense){
      return '(971) 673-0540 (option 3)';
    }
    if(this.data.entityType === this.sharedService.hospitalLicense){
      return '971-673-0540';
    }
    return '';
  }

  formatAmount(amount: any): string {
    if (typeof amount === 'string' && amount.includes(',')) {
      return amount;
    }

    const numAmount = typeof amount === 'number' ? amount : parseFloat(amount);

    if (!isNaN(numAmount)) {
      return numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    return String(amount);
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }

}
